<ng-container *ngIf="!init || executionState == null; else tourItemDisplay">
  <div class="loading">
    <mat-spinner
      style="margin: auto"
      color="primary"
      diameter="24"
    ></mat-spinner>
  </div>
</ng-container>

<ng-template #tourItemDisplay>
  <ng-container *ngIf="subProject != null">
    <div class="ipad-tour-item-container">
      <div class="button-container">
        <div class="action-buttons">
          <div class="navigation-link clickable action-button waze-link">
            <img
              src="../../../../../assets/waze-icon.png"
              width="30px"
              height="30px"
            />

            <a
              class="waze-link-margin"
              href="{{
                subProject.projectPlacement?.address?.line1
                  | wazeLink
                    : subProject.projectPlacement?.address?.city
                    : subProject.projectPlacement?.address?.postalCode
                    : subProject.projectPlacement?.address?.country
                    : subProject.projectPlacement?.address?.coordinates?.lat
                    : subProject.projectPlacement?.address?.coordinates?.lng
              }}"
              target="_blank"
            >
              Start navigatie
            </a>
          </div>

          <div class="placement-button">
            <button
              class="start-timer action-button clickable placement-button-height"
              [disabled]="
                executionState.executed != null ||
                executionState.placementStarted
              "
              [ngClass]="
                executionState.executed != null ||
                executionState.placementStarted
                  ? 'start-timer-disabled'
                  : ''
              "
              (click)="startPlacement()"
            >
              <div class="d-flex">
                <mat-icon
                  [ngClass]="
                    executionState.placementStarted
                      ? 'placement-started-schedule-icon'
                      : 'schedule-icon'
                  "
                >
                  schedule
                </mat-icon>

                <div class="start-text">
                  {{
                    executionState.placementStarted
                      ? 'Uitvoering gestart'
                      : 'Start uitvoering'
                  }}
                </div>
              </div>
            </button>
          </div>
        </div>

        <div class="project-id align-right">
          <div>#{{ subProject.project?.id }}</div>

          <div
            *ngIf="subProject.project?.oldPlatformId != null"
            class="font-italic"
            [matTooltip]="'Jobnummer oud platform'"
          >
            ({{ subProject.project.oldPlatformId }})
          </div>
        </div>
      </div>

      <client-adjustment-header
        [type]="lowerCaseType"
        [title]="subProject.typeDisplay"
        [projectContacts]="subProject?.project?.projectContacts"
        [requestContact]="subProject.subProjectContact"
        [extraCompanyContacts]="
          subProject?.project?.projectExtraCompanyContacts
        "
        [client]="false"
        [placer]="true"
        [currentCreatedAt]="subProject.currentCreatedAt"
        [projectId]="subProject.project.id"
        [address]="subProject.projectPlacement.address"
      ></client-adjustment-header>

      <ng-container
        *ngIf="
          subProject.type !== SUB_PROJECT_TYPES.BASE_PROJECT &&
          !!baseProjectPlacement
        "
      >
        <client-adjustment-summary
          [address]="baseProjectPlacement.address"
          [placementFloor]="baseProjectPlacement.placementFloor"
          [executionAssets]="subProjectAssets.latestExecutionAssets"
          [secondBoard]="baseProjectPlacement.secondBoard"
          [otherOrderPlacementInfo]="
            baseProjectPlacement.otherOrderPlacementInfo
          "
          [products]="subProject.project.products"
          [baseProjectTour]="baseProjectTour"
          [baseProjectDoneRegistration]="baseProjectDoneRegistration"
          [adjustment]="subProject"
        ></client-adjustment-summary>
      </ng-container>

      <div
        *ngIf="timeBudgetDisplay?.length > 0"
        class="upper-space strong horizontal-center"
      >
        Voorziene tijd {{ subProject.typeDisplay | lowercase }}:
        {{ timeBudgetDisplay }}
      </div>

      <ng-container
        *ngIf="
          appointmentInfo != null &&
          (appointmentInfo.appointmentTimeOfDay?.length > 0 ||
            appointmentInfo.appointmentContactDisplay?.length > 0 ||
            appointmentInfo.needAppointmentInfo?.length > 0)
        "
      >
        <div
          class="upper-space tour-item-form-compartment center-content form-banner appointment appointment-info"
        >
          <div>
            <div class="d-flex preserve-line-break">
              <div class="strong">Afspraak:&nbsp;</div>
              <div *ngIf="appointmentInfo.appointmentTimeOfDay?.length > 0">
                <span>{{ appointmentInfo.appointmentTimeOfDay }}</span>
              </div>
              <div
                *ngIf="
                  appointmentInfo.appointmentTimeOfDay?.length > 0 &&
                  appointmentInfo.needAppointmentInfo?.length > 0
                "
              >
                <span> - </span>
              </div>
              <div *ngIf="appointmentInfo.needAppointmentInfo?.length > 0">
                <span>{{ appointmentInfo.needAppointmentInfo }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="
          appointmentInfo != null &&
          appointmentInfo.collectKeyAddress?.length > 0
        "
      >
        <div
          class="upper-space tour-item-form-compartment center-content form-banner appointment"
        >
          <div>
            <div>
              <span class="strong">Sleutel&nbsp;afhalen:&nbsp;</span>

              <span>{{ appointmentInfo.collectKeyAddress }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="
          appointmentInfo != null &&
          (appointmentInfo.appointmentContactDisplay?.length > 0 ||
            appointmentInfo.appointmentRegistration?.length > 0)
        "
      >
        <div
          class="upper-space tour-item-form-compartment center-content"
          [ngClass]="appointmentInfo.appointmentFailure ? 'noAppointment' : ''"
        >
          <div>
            <div
              class="d-flex flex-column align-items-center preserve-line-break"
            >
              <div
                *ngIf="appointmentInfo.appointmentContactDisplay?.length > 0"
              >
                <span class="strong">Contactpersoon:&nbsp;</span>
                <span>{{ appointmentInfo.appointmentContactDisplay }}</span>
              </div>
              <div *ngIf="appointmentInfo.appointmentRegistration?.length > 0">
                <span *ngIf="appointmentInfo.appointmentReady" class="strong"
                  >Afspraak klaar:&nbsp;</span
                >
                <span *ngIf="appointmentInfo.appointmentFailure" class="strong"
                  >Nog geen afspraak:&nbsp;</span
                >
                <span class="italic">{{
                  appointmentInfo.appointmentRegistration
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <div
        class="upper-space tour-item-form-compartment center-content form-banner appointment"
        *ngIf="
          subProject.type !== SUB_PROJECT_TYPES.BASE_PROJECT &&
          soldRentedStickerInfo != null &&
          (soldRentedStickerInfo.stickerInfo?.length > 0 ||
            soldRentedStickerInfo.amount?.length > 0)
        "
      >
        <div class="d-flex">
          <div class="strong">Sticker&nbsp;info:&nbsp;</div>

          <div class="preserve-line-break">
            <div *ngIf="soldRentedStickerInfo.stickerInfo?.length > 0">
              {{ soldRentedStickerInfo.stickerInfo }}
            </div>

            <div *ngIf="soldRentedStickerInfo.amount?.length > 0">
              Aantal:
              <strong>{{ soldRentedStickerInfo.amount }}</strong>
            </div>
          </div>
        </div>
      </div>

      <div
        class="upper-space tour-item-form-compartment center-content form-banner internal-info"
        [class.filled]="subProject.internalInfo?.length > 0"
      >
        <div class="d-flex strong w-100">
          <div class="w-100">
            <mat-form-field class="w-100" appearance="outline">
              <textarea
                matInput
                [(ngModel)]="subProject.internalInfo"
                placeholder="Interne info kan je hier invoeren"
                (change)="
                  internalInfoChanged(
                    $event.target.value,
                    subProject.recurringInternalInfo
                  )
                "
                cdkTextareaAutosize
              ></textarea>
            </mat-form-field>

            <div class="recurring-internal-info-container">
              <mat-checkbox
                [(ngModel)]="subProject.recurringInternalInfo"
                [disabled]="isInstaller()"
                (ngModelChange)="
                  internalInfoChanged(
                    subProject.internalInfo,
                    subProject.recurringInternalInfo
                  )
                "
              >
                Toon bij elke volgende actie bovenvermelde info
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="
          subProject.type !== SUB_PROJECT_TYPES.REPO &&
          firstIPBoardWrapper.ipBoard.boardPart.sign?.installerInfo?.length > 0
        "
        class="upper-space tour-item-form-compartment form-banner appointment installer-info"
      >
        <div>
          <span class="strong">Installateur&nbsp;info:&nbsp;</span>
          <span class="preserve-line-break">
            {{ firstIPBoardWrapper.ipBoard.boardPart.sign?.installerInfo }}
          </span>
        </div>
      </div>

      <ng-container
        *ngIf="
          subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT;
          else adjustmentDisplay
        "
      >
        <div
          class="upper-space tour-item-form-compartment center-content"
          style="margin-bottom: 0"
        >
          <ng-container
            *ngIf="
              getInstallerPdfUrl(
                firstIPBoardWrapper?.ipBoard?.boardPart
              ) as pdfResult;
              else noPdf
            "
          >
            <!-- Multiple PDF options -->
            <ng-container *ngIf="pdfResult && isObject(pdfResult)">
              <div class="pdf-options-container">
                <div *ngFor="let pdfOption of objectKeys(pdfResult)">
                  <a
                    [href]="pdfResult[pdfOption]"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-primary"
                    style="
                      font-weight: 600;
                      font-size: 16px;
                      display: inline-flex;
                      align-items: center;
                      gap: 8px;
                      margin-bottom: 8px;
                    "
                  >
                    <mat-icon>picture_as_pdf</mat-icon>
                    {{ getPdfButtonLabel(pdfOption) }}
                  </a>
                </div>
              </div>
            </ng-container>

            <!-- Single PDF option -->
            <ng-container *ngIf="pdfResult && isString(pdfResult)">
              <a
                [href]="pdfResult"
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-primary"
                style="
                  font-weight: 600;
                  font-size: 16px;
                  display: inline-flex;
                  align-items: center;
                  gap: 8px;
                "
              >
                <mat-icon>picture_as_pdf</mat-icon>
                Bekijk installatieinstructies
              </a>
            </ng-container>
          </ng-container>
          <ng-template #noPdf>
            <div
              class="alert alert-warning"
              style="
                font-weight: 600;
                font-size: 16px;
                display: flex;
                align-items: center;
                gap: 8px;
                color: #b26a00;
              "
            >
              <mat-icon>error_outline</mat-icon>
              Geen installatie-instructies beschikbaar.
            </div>
          </ng-template>
        </div>

        <project-detail-card
          [cardType]="'configuration'"
          [products]="subProject.project.products"
          [firstProduct]="subProject.project.products[0]"
          [project]="subProject.project"
          [client]="true"
          [installerView]="true"
        ></project-detail-card>

        <project-detail-card
          [cardType]="'design'"
          [products]="subProject.project.products"
          [assets]="subProjectAssets.designAssets"
          [ipBoardExamples]="subProjectAssets.ipBoardExamples"
          [project]="subProject.project"
        ></project-detail-card>

        <project-detail-card
          [cardType]="'placement'"
          [firstProduct]="subProject.project.products[0]"
          [projectPlacement]="subProject.projectPlacement"
          [baseProject]="subProject"
          [project]="subProject.project"
          [assets]="subProjectAssets.sitePhotos"
          [installerView]="true"
          (addressChanged)="addressChanged($event)"
        ></project-detail-card>
      </ng-container>

      <ng-template #adjustmentDisplay>
        <div
          class="upper-space tour-item-form-compartment adjustment-info d-flex justify-content-between"
        >
          <div>
            <div class="d-flex">
              <label class="ft-18 mt-auto mb-auto mr-2">
                <ng-container
                  *ngIf="
                    subProject.type === SUB_PROJECT_TYPES.SOLDRENTED;
                    else typeDisplay
                  "
                >
                  <ng-container
                    *ngIf="
                      subProject.signSticker?.text?.length > 0 ||
                        subProject.otherSticker?.length > 0;
                      else unspecifiedSticker
                    "
                  >
                    "{{
                      !!adjustment.signSticker
                        ? adjustment.signSticker.text
                        : adjustment.otherSticker
                    }}"
                  </ng-container>

                  <ng-template #unspecifiedSticker> Sticker</ng-template>
                </ng-container>

                <ng-template #typeDisplay>
                  {{ subProject.typeDisplay }}
                </ng-template>
              </label>

              <img
                class="marker"
                src="/assets/markers/{{
                  subProject.type === SUB_PROJECT_TYPES.ADJUSTMENT
                    ? 'Blauw'
                    : subProject.type === SUB_PROJECT_TYPES.SOLDRENTED
                    ? 'Geel'
                    : 'Rood'
                }}.png"
                alt="marker"
                width="22"
                height="32"
              />
            </div>

            <div
              class="mt-3"
              *ngIf="
                adjustment.extraInfoAdjustment != null &&
                adjustment.extraInfoAdjustment != ''
              "
            >
              <label *ngIf="subProject.type != SUB_PROJECT_TYPES.ADJUSTMENT">
                Opmerkingen van de klant:
              </label>

              <p>{{ adjustment.extraInfoAdjustment }}</p>
            </div>

            <div
              *ngIf="
                (subProject.type !== SUB_PROJECT_TYPES.ADJUSTMENT &&
                  subProject.project?.firstProduct?.productPlacement?.arrows
                    ?.amountArrowsLeft != null) ||
                subProject.project?.firstProduct?.productPlacement?.arrows
                  ?.amountArrowsRight != null ||
                baseProjectPlacement?.secondBoard != null ||
                baseProjectPlacement?.otherOrderPlacementInfo
              "
              class="d-flex mt-4 mb-0"
            >
              <ul class="inpress-ul mb-0">
                <li
                  *ngIf="
                    (subProject.project?.firstProduct?.productPlacement?.arrows
                      ?.amountArrowsLeft != null ||
                      subProject.project?.firstProduct?.productPlacement?.arrows
                        ?.amountArrowsRight != null) &&
                    subProject.type === SUB_PROJECT_TYPES.REPO
                  "
                >
                  <div class="inline-table">
                    <div class="strong">Pijltjes</div>

                    <div
                      *ngIf="
                        subProject.project?.firstProduct?.productPlacement
                          .arrows.amountArrowsLeft > 0
                      "
                    >
                      Aantal links:
                      {{
                        subProject.project?.firstProduct?.productPlacement
                          .arrows.amountArrowsLeft
                      }}
                    </div>

                    <div
                      *ngIf="
                        subProject.project?.firstProduct?.productPlacement
                          .arrows.amountArrowsRight > 0
                      "
                    >
                      Aantal rechts:
                      {{
                        subProject.project?.firstProduct?.productPlacement
                          .arrows.amountArrowsRight
                      }}
                    </div>

                    <div
                      *ngIf="
                        subProject.project?.firstProduct?.productPlacement
                          .arrows.arrowsLocation?.length > 0
                      "
                      class="preserve-new-line"
                    >
                      {{
                        subProject.project?.firstProduct?.productPlacement
                          .arrows.arrowsLocation
                      }}
                    </div>
                  </div>
                </li>

                <li
                  *ngIf="
                    baseProjectPlacement?.secondBoard != null &&
                    (subProject.type === SUB_PROJECT_TYPES.SOLDRENTED ||
                      subProject.type === SUB_PROJECT_TYPES.REPO)
                  "
                >
                  <div class="inline-table">
                    <div class="strong">Tweede bord op hetzelfde pand</div>

                    <div
                      *ngIf="
                        baseProjectPlacement.secondBoard
                          .secondBoardPlacementInfo?.length > 0
                      "
                      class="preserve-new-line"
                    >
                      {{
                        baseProjectPlacement.secondBoard
                          .secondBoardPlacementInfo
                      }}
                    </div>
                  </div>
                </li>

                <li
                  *ngIf="
                    subProject.type === SUB_PROJECT_TYPES.REPO &&
                    baseProjectPlacement?.otherOrderPlacementInfo?.length > 0
                  "
                >
                  <div class="inline-table">
                    <div class="strong">Andere bestelling</div>

                    <div class="preserve-new-line">
                      {{ baseProjectPlacement.otherOrderPlacementInfo }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div class="mt-5">
              <label>Afspraak nodig?</label>

              <p>
                {{
                  subProject.projectPlacement.appointment != null &&
                  subProject.projectPlacement.appointment
                    ? 'Ja'
                    : 'Nee'
                }}
              </p>
            </div>

            <div class="mt-2">
              <label>Sleutel afhalen?</label>

              <p>
                {{
                  subProject.projectPlacement.collectKey != null &&
                  subProject.projectPlacement.collectKey
                    ? 'Ja'
                    : 'Nee'
                }}
              </p>
            </div>

            <div
              class="mt-5"
              *ngIf="
                subProject.currentRequestASAP ||
                subProject.currentRequestDate != null
              "
            >
              <label>Wanneer uitvoeren?</label>

              <p>
                Gewenste uitvoeringsdatum:
                <ng-container *ngIf="subProject.currentRequestASAP; else date">
                  ASAP
                </ng-container>

                <ng-template #date>
                  <span class="strong accent ft-16">
                    {{ subProject.currentRequestDate | date : 'dd/MM/yyyy' }}
                  </span>
                </ng-template>
              </p>
            </div>
          </div>

          <div class="asset-container">
            <ng-container *ngIf="adjustmentDisplayAssets?.length > 0">
              <div
                class="displayable-asset-container"
                *ngFor="let asset of adjustmentDisplayAssets; let i = index"
              >
                <div
                  class="sign-example clickable"
                  [ngStyle]="asset.backgroundImageStyle"
                  (click)="openDetailAssetLightbox(adjustmentDisplayAssets, i)"
                ></div>
              </div>
            </ng-container>

            <div
              *ngIf="subProjectAssets.pdfAdjustmentAssets?.length > 0"
              class="pdf-container"
            >
              <ul>
                <li *ngFor="let pdf of subProjectAssets.pdfAdjustmentAssets">
                  <a
                    target="_blank"
                    href="/api/assets/{{ pdf.uuid }}"
                    style="margin-right: 7px"
                    class="d-flex box"
                  >
                    <mat-icon> picture_as_pdf</mat-icon>

                    <div class="filename">{{ pdf?.name }}</div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <ng-container
          *ngIf="
            subProject.type === SUB_PROJECT_TYPES.SOLDRENTED &&
            soldRentedStickerInfo?.installerInfo?.length > 0
          "
        >
          <div
            class="upper-space tour-item-form-compartment center-content form-banner appointment"
          >
            <div class="d-flex">
              <div class="strong">Sticker info:&nbsp;</div>

              <div class="preserve-line-break">
                <span>{{ soldRentedStickerInfo.installerInfo }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-template>

      <div
        class="upper-space tour-item-form-compartment center-content divider-banner strong execution-header"
      >
        <span *ngIf="placerName?.length > 0; else noPlacer">
          Uitvoering: {{ placerName | joiner : ' - ' : planningDate }}
        </span>

        <ng-template #noPlacer>
          <span>Uitvoering: Job zit niet in toer</span>
        </ng-template>
      </div>

      <ng-container
        *ngIf="
          subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT &&
          firstIPBoardWrapper?.ipBoard?.boardPart?.sign?.installerValue &&
          firstIPBoardWrapper.ipBoard.boardPart.sign.installerInfo?.length > 0
        "
      >
      </ng-container>

      <div class="tour-item-form-compartment job-info job-info-execution">
        <ng-container
          *ngIf="
            subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT;
            else showAdjustmentCompletion
          "
        >
          <div class="completion-container">
            <ng-container
              *ngTemplateOutlet="baseProjectCompletion"
            ></ng-container>
          </div>
        </ng-container>

        <ng-template #showAdjustmentCompletion>
          <div class="completion-container">
            <ng-container
              *ngTemplateOutlet="adjustmentCompletion"
            ></ng-container>
          </div>
        </ng-template>

        <div class="float-right">
          <div class="d-flex">
            <ng-container
              *ngIf="
                submitInProgress ||
                submitQueued ||
                immoIPPlacerTourItemDetailChangeStorageHandler?.isSubmitting ||
                immoIPPlacerTourItemDetailChangeStorageHandler?.isStoringOfflineChange
              "
            >
              <button
                *ngIf="submitQueued && !submitInProgress"
                mat-button
                class="button executed-button"
                [disabled]="
                  immoIPPlacerTourItemDetailChangeStorageHandler?.isSubmitting
                "
                (click)="retrySubmit()"
              >
                Manueel opnieuw proberen
              </button>

              <div
                *ngIf="submitQueued && !submitInProgress"
                matTooltip="Project staat klaar om ingediend te worden"
              >
                <mat-icon class="queue-icon">cloud_queue</mat-icon>
              </div>

              <div
                *ngIf="
                  submitInProgress ||
                  immoIPPlacerTourItemDetailChangeStorageHandler?.isSubmitting ||
                  immoIPPlacerTourItemDetailChangeStorageHandler?.isStoringOfflineChange
                "
                matTooltip="Opdracht wordt ingediend"
              >
                <mat-spinner
                  class="submitting-icon"
                  color="primary"
                  diameter="30"
                ></mat-spinner>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                !submitInProgress &&
                !immoIPPlacerTourItemDetailChangeStorageHandler?.isSubmitting &&
                !immoIPPlacerTourItemDetailChangeStorageHandler?.isStoringOfflineChange
              "
            >
              <ng-container
                *ngIf="
                  executionState.executed &&
                  notExecutedHistoryItemObject == null
                "
              >
                <button class="btn button reset-button" (click)="doReset(true)">
                  Reset
                </button>
              </ng-container>
              <ng-container
                *ngIf="
                  !executionState.executed &&
                    notExecutedHistoryItemObject == null;
                  else changesBtn
                "
              >
                <button
                  mat-button
                  class="button not-executed-button"
                  (click)="openNotExecutedModal()"
                >
                  Niet uitgevoerd
                </button>

                <button
                  mat-button
                  class="button executed-button button-left-space"
                  [disabled]="
                    !executionState.placementStarted ||
                    executionState.executed ||
                    !executionState.allowExecuted
                  "
                  (click)="submitExecuted()"
                >
                  Uitgevoerd
                </button>
              </ng-container>

              <ng-template #changesBtn>
                <button
                  mat-button
                  class="button not-executed-button"
                  [class.saved]="saved"
                  *ngIf="
                    notExecutedHistoryItemObject != null &&
                    !!!executionState.executed
                  "
                  [disabled]="
                    notExecutedHistoryItemObject.content?.length <= 0 ||
                    (subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT &&
                      notExecutedHistoryItemObject.assets?.length <= 0 &&
                      notExecutedHistoryItemObject.offlineAssets?.length <= 0)
                  "
                  (click)="submitChanges()"
                >
                  <span
                    [matTooltip]="
                      notExecutedHistoryItemObject.content?.length <= 0
                        ? 'Reden mag niet leeg zijn'
                        : !disabled
                        ? 'Er moet minstens één foto toegevoegd zijn'
                        : ''
                    "
                    [matTooltipDisabled]="
                      !(
                        notExecutedHistoryItemObject.content?.length <= 0 ||
                        (subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT &&
                          notExecutedHistoryItemObject.assets?.length <= 0 &&
                          notExecutedHistoryItemObject.offlineAssets?.length <=
                            0)
                      )
                    "
                  >
                    {{
                      !saved
                        ? 'Feedback wijziging opslaan'
                        : 'Feedback wijziging opgeslagen'
                    }}
                  </span>
                </button>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<!-- COMPLETION SECTIONS -->

<ng-template #baseProjectCompletion>
  <ng-container *ngIf="firstIPBoardWrapper?.ipBoard?.productPlacement != null">
    <div class="d-flex w-100">
      <div class="completion-content-container">
        <div class="upper-space">
          <tour-item-registered
            [tourItem]="subProject?.tourItem"
          ></tour-item-registered>
        </div>
        <div class="d-flex upper-space">
          <div class="align-textarea-label">
            <div class="font-16 secondary-color strong">
              Feedback installateur:
            </div>
          </div>

          <div class="left-space flexer">
            <textarea-input
              [initContent]="
                firstIPBoardWrapper.ipBoard.productPlacement.installerFeedback
              "
              [placeholder]="'Heb je opmerkingen, noteer hier uw info.'"
              [disabled]="reloading || !executionState.placementStarted"
              [client]="true"
              (answer)="
                installerFeedbackChanged($event, firstIPBoardWrapper.ipBoard)
              "
            ></textarea-input>
          </div>
        </div>

        <div class="to-do-item-container half-width">
          <div class="to-do-item">
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.placed.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.placed,
                  firstIPBoardWrapper.ipBoard,
                  'placed'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.placed.label | shortenText : 30 }}
              </span>
            </mat-checkbox>
          </div>

          <div
            *ngIf="firstIPBoardWrapper.extraBoard != null"
            class="to-do-item"
          >
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.extraBoard.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.extraBoard,
                  firstIPBoardWrapper.ipBoard,
                  'extraBoard'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.extraBoard.label | shortenText : 30 }}
              </span>
            </mat-checkbox>
          </div>

          <div *ngIf="firstIPBoardWrapper.text != null" class="to-do-item">
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.text.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.text,
                  firstIPBoardWrapper.ipBoard,
                  'text'
                )
              "
            >
              <span class="strong">{{ firstIPBoardWrapper.text.label }}</span>
            </mat-checkbox>
          </div>

          <div *ngIf="firstIPBoardWrapper.leftTitle != null" class="to-do-item">
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.leftTitle.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.leftTitle,
                  firstIPBoardWrapper.ipBoard,
                  'leftTitle'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.leftTitle.label }}
              </span>
            </mat-checkbox>
          </div>

          <div
            *ngIf="firstIPBoardWrapper.rightTitle != null"
            class="to-do-item"
          >
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.rightTitle.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.rightTitle,
                  firstIPBoardWrapper.ipBoard,
                  'rightTitle'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.rightTitle.label }}
              </span>
            </mat-checkbox>
          </div>

          <div
            *ngIf="firstIPBoardWrapper.leftPhoneNumber != null"
            class="to-do-item"
          >
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.leftPhoneNumber.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.leftPhoneNumber,
                  firstIPBoardWrapper.ipBoard,
                  'leftPhoneNumber'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.leftPhoneNumber.label }}
              </span>
            </mat-checkbox>
          </div>

          <div
            *ngIf="firstIPBoardWrapper.rightPhoneNumber != null"
            class="to-do-item"
          >
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.rightPhoneNumber.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.rightPhoneNumber,
                  firstIPBoardWrapper.ipBoard,
                  'rightPhoneNumber'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.rightPhoneNumber.label }}
              </span>
            </mat-checkbox>
          </div>

          <div *ngIf="firstIPBoardWrapper.sticker != null" class="to-do-item">
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.sticker.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.sticker,
                  firstIPBoardWrapper.ipBoard,
                  'sticker'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.sticker.label }}
              </span>
            </mat-checkbox>
          </div>

          <div *ngIf="firstIPBoardWrapper.poleColor != null" class="to-do-item">
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.poleColor.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.poleColor,
                  firstIPBoardWrapper.ipBoard,
                  'poleColor'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.poleColor.label }}
              </span>
            </mat-checkbox>
          </div>

          <div *ngIf="firstIPBoardWrapper.immoscoop != null" class="to-do-item">
            <mat-checkbox
              [ariaLabel]=""
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.immoscoop.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.immoscoop,
                  firstIPBoardWrapper.ipBoard,
                  'immoscoop'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.immoscoop.label }}
              </span>
            </mat-checkbox>
          </div>

          <div *ngIf="firstIPBoardWrapper.spotto != null" class="to-do-item">
            <mat-checkbox
              [ariaLabel]=""
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.spotto.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.spotto,
                  firstIPBoardWrapper.ipBoard,
                  'spotto'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.spotto.label }}
              </span>
            </mat-checkbox>
          </div>

          <div *ngIf="subProjectToDoItems?.extras != null" class="to-do-item">
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="subProjectToDoItems.extras.done"
              (ngModelChange)="
                subProjectToDoItemChanged(subProjectToDoItems.extras, 'extras')
              "
            >
              <span class="strong">{{ subProjectToDoItems.extras.label }}</span>
            </mat-checkbox>
          </div>

          <div *ngIf="firstIPBoardWrapper.safetyNut != null" class="to-do-item">
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.safetyNut.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.safetyNut,
                  firstIPBoardWrapper.ipBoard,
                  'safetyNut'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.safetyNut.label }}
              </span>
            </mat-checkbox>
          </div>

          <div
            *ngIf="firstIPBoardWrapper.extraHeight != null"
            class="to-do-item"
          >
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.extraHeight.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.extraHeight,
                  firstIPBoardWrapper.ipBoard,
                  'extraHeight'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.extraHeight.label }}
              </span>
            </mat-checkbox>
          </div>

          <div
            *ngIf="firstIPBoardWrapper.safetyRibbon != null"
            class="to-do-item"
          >
            <mat-checkbox
              [disabled]="!executionState.placementStarted || reloading"
              [(ngModel)]="firstIPBoardWrapper.safetyRibbon.done"
              (ngModelChange)="
                toDoItemChanged(
                  firstIPBoardWrapper.safetyRibbon,
                  firstIPBoardWrapper.ipBoard,
                  'safetyRibbon'
                )
              "
            >
              <span class="strong">
                {{ firstIPBoardWrapper.safetyRibbon.label }}
              </span>
            </mat-checkbox>
          </div>
        </div>

        <div
          *ngIf="firstIPBoardWrapper.installerInfo != null"
          class="to-do-item-important"
        >
          <mat-checkbox
            [disabled]="!executionState.placementStarted || reloading"
            [(ngModel)]="firstIPBoardWrapper.installerInfo.done"
            (ngModelChange)="
              toDoItemChanged(
                firstIPBoardWrapper.installerInfo,
                firstIPBoardWrapper.ipBoard,
                'installerInfo'
              )
            "
          >
            <span class="strong">
              {{ firstIPBoardWrapper.installerInfo.label }}
            </span>
          </mat-checkbox>
        </div>
      </div>

      <div class="completion-images-container more-upper-space d-flex">
        <div class="align-file-picker">
          <file-picker
            [formSection]="'execution'"
            [inputProduct]="firstIPBoardWrapper.ipBoard"
            [uploadButtonLabel]="'Foto toevoegen'"
            [noLeftSpace]="true"
            [offlineUpload]="true"
            [disabled]="
              (!executionState.placementStarted && !executionState.executed) ||
              reloading ||
              notExecutedHistoryItemObject != null
            "
            [hideUpload]="notExecutedHistoryItemObject != null"
            [disabledErrorMessage]="
              !executionState.placementStarted
                ? 'Gelieve de uitvoering eerst te starten'
                : 'Het systeem is bezig met wijzigingen op te slaan'
            "
            (answer)="productAssetStored(firstIPBoardWrapper.ipBoard)"
            (assetDeleted)="productAssetDeleted(firstIPBoardWrapper.ipBoard)"
          ></file-picker>
        </div>
      </div>
    </div>

    <div class="position-relative blur-container">
      <div *ngIf="showPlacementConfigModal" class="placement-config-modal">
        <div class="d-flex justify-content-between">
          <p class="title strong">Configuratie van het bord aanpassen</p>

          <mat-icon
            class="close-icon"
            (click)="showPlacementConfigModal = false"
          >
            close
          </mat-icon>
        </div>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Type bord</mat-label>

          <mat-select
            [compareWith]="compareBoardTypesFn"
            [(ngModel)]="selectedBoardType"
          >
            <mat-option
              *ngFor="let boardType of boardTypeChoicesArray"
              [value]="boardType"
            >
              {{ boardType.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <br />

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Type plaatsing</mat-label>

          <mat-select
            [compareWith]="comparePlacementTypesFn"
            [(ngModel)]="selectedPlacementType"
          >
            <mat-option
              *ngFor="let placementType of placementTypeChoicesArray"
              [value]="placementType"
            >
              {{ placementType.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <br />

        <div class="d-flex">
          <ng-container
            *ngIf="
              submitInProgress ||
                immoIPPlacerTourItemDetailChangeStorageHandler?.isSubmitting ||
                immoIPPlacerTourItemDetailChangeStorageHandler?.isStoringOfflineChange;
              else saveBtn
            "
          >
            <mat-spinner
              class="submitting-icon ml-auto mr-0"
              color="primary"
              diameter="30"
            ></mat-spinner>
          </ng-container>

          <ng-template #saveBtn>
            <button
              mat-button
              class="placement-config-save-btn ml-auto mr-0"
              (click)="savePlacementConfigUpdate()"
            >
              Opslaan
            </button>
          </ng-template>
        </div>
      </div>

      <button
        mat-button
        class="button placement-config-btn ml-0 mb-0"
        (click)="showPlacementConfigModal = !showPlacementConfigModal"
        [disabled]="!!executionState.executed"
      >
        Config veranderen
      </button>
    </div>

    <ng-container *ngTemplateOutlet="notExecutedDisplay"></ng-container>
  </ng-container>
</ng-template>

<ng-template #adjustmentCompletion>
  <div class="w-100 d-flex">
    <div class="completion-content-container">
      <div class="upper-space">
        <tour-item-registered
          [tourItem]="subProject?.tourItem"
        ></tour-item-registered>
      </div>
      <div class="d-flex upper-space">
        <ng-container *ngIf="subProject?.projectPlacement != null">
          <div class="align-textarea-label">
            <div class="font-16 secondary-color strong">
              Feedback installateur:
            </div>
          </div>

          <div class="left-space flexer">
            <textarea-input
              [initContent]="subProject?.projectPlacement.placerFeedback"
              [placeholder]="'Heb je opmerkingen, noteer hier uw info'"
              [disabled]="reloading"
              [client]="true"
              (answer)="placerFeedbackChanged($event)"
            ></textarea-input>
          </div>
        </ng-container>
      </div>

      <div class="d-flex">
        <div class="flex-0-5">
          <div class="to-do-item-container">
            <div
              *ngIf="subProjectToDoItems?.completed != null"
              class="to-do-item"
            >
              <div class="align-checkbox flex-0-6">
                <mat-checkbox
                  [ariaLabel]=""
                  [disabled]="!executionState.placementStarted || reloading"
                  [(ngModel)]="subProjectToDoItems.completed.done"
                  (ngModelChange)="
                    subProjectToDoItemChanged(
                      subProjectToDoItems.completed,
                      'completed'
                    )
                  "
                >
                  <span class="strong">
                    {{ subProjectToDoItems.completed.label }}
                  </span>
                </mat-checkbox>
              </div>
            </div>

            <div
              *ngIf="subProjectToDoItems?.stickerInfo != null"
              class="to-do-item"
            >
              <div class="align-checkbox flex-0-6">
                <mat-checkbox
                  [ariaLabel]=""
                  [disabled]="!executionState.placementStarted || reloading"
                  [(ngModel)]="subProjectToDoItems.stickerInfo.done"
                  (ngModelChange)="
                    subProjectToDoItemChanged(
                      subProjectToDoItems.stickerInfo,
                      'stickerInfo'
                    )
                  "
                >
                  <span class="strong">
                    {{ subProjectToDoItems.stickerInfo.label }}
                  </span>
                </mat-checkbox>
              </div>
            </div>

            <div *ngIf="subProjectToDoItems?.extras != null" class="to-do-item">
              <div class="align-checkbox flex-0-6">
                <mat-checkbox
                  [ariaLabel]=""
                  [disabled]="!executionState.placementStarted || reloading"
                  [(ngModel)]="subProjectToDoItems.extras.done"
                  (ngModelChange)="
                    subProjectToDoItemChanged(
                      subProjectToDoItems.extras,
                      'extras'
                    )
                  "
                >
                  <span class="strong">
                    {{ subProjectToDoItems.extras.label }}
                  </span>
                </mat-checkbox>
              </div>
            </div>

            <div *ngIf="subProjectToDoItems?.arrows != null" class="to-do-item">
              <div class="align-checkbox flex-0-6">
                <mat-checkbox
                  [ariaLabel]=""
                  [disabled]="!executionState.placementStarted || reloading"
                  [(ngModel)]="subProjectToDoItems.arrows.done"
                  (ngModelChange)="
                    subProjectToDoItemChanged(
                      subProjectToDoItems.arrows,
                      'arrows'
                    )
                  "
                >
                  <span class="strong">
                    {{ subProjectToDoItems.arrows.label }}
                  </span>
                </mat-checkbox>
              </div>
            </div>

            <div
              *ngIf="subProjectToDoItems?.secondBoard != null"
              class="to-do-item"
            >
              <div class="align-checkbox flex-0-6">
                <mat-checkbox
                  [ariaLabel]=""
                  [disabled]="!executionState.placementStarted || reloading"
                  [(ngModel)]="subProjectToDoItems.secondBoard.done"
                  (ngModelChange)="
                    subProjectToDoItemChanged(
                      subProjectToDoItems.secondBoard,
                      'secondBoard'
                    )
                  "
                >
                  <span class="strong">
                    {{ subProjectToDoItems.secondBoard.label }}
                  </span>
                </mat-checkbox>
              </div>
            </div>

            <div
              *ngIf="subProjectToDoItems?.otherOrder != null"
              class="to-do-item"
            >
              <div class="align-checkbox flex-0-6">
                <mat-checkbox
                  [ariaLabel]=""
                  [disabled]="!executionState.placementStarted || reloading"
                  [(ngModel)]="subProjectToDoItems.otherOrder.done"
                  (ngModelChange)="
                    subProjectToDoItemChanged(
                      subProjectToDoItems.otherOrder,
                      'otherOrder'
                    )
                  "
                >
                  <span class="strong">
                    {{ subProjectToDoItems.otherOrder.label }}
                  </span>
                </mat-checkbox>
              </div>
            </div>

            <div
              *ngIf="subProjectToDoItems?.drillHolesFilled != null"
              class="to-do-item"
            >
              <div class="align-checkbox flex-0-6">
                <mat-checkbox
                  [ariaLabel]=""
                  [disabled]="!executionState.placementStarted || reloading"
                  [(ngModel)]="subProjectToDoItems.drillHolesFilled.done"
                  (ngModelChange)="
                    subProjectToDoItemChanged(
                      subProjectToDoItems.drillHolesFilled,
                      'drillHolesFilled'
                    )
                  "
                >
                  <span class="strong">
                    {{ subProjectToDoItems.drillHolesFilled.label }}
                  </span>
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="
        subProject.type !== SUB_PROJECT_TYPES.REPO &&
        subProject.projectPlacement != null
      "
      class="completion-images-container"
    >
      <div class="more-upper-space d-flex">
        <div class="align-file-picker">
          <file-picker
            [formSection]="'adjustmentPlacementSuccess'"
            [inputProjectPlacement]="subProject.projectPlacement"
            [uploadButtonLabel]="'Foto toevoegen'"
            [noLeftSpace]="true"
            [offlineUpload]="true"
            [disabled]="
              (!executionState.placementStarted && !executionState.executed) ||
              reloading ||
              notExecutedHistoryItemObject != null
            "
            [hideUpload]="notExecutedHistoryItemObject != null"
            [disabledErrorMessage]="
              !executionState.placementStarted
                ? 'Gelieve de uitvoering eerst te starten'
                : 'Het systeem is bezig met wijzigingen op te slaan'
            "
            (answer)="projectAssetStored()"
            (assetDeleted)="projectAssetDeleted()"
          ></file-picker>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngTemplateOutlet="notExecutedDisplay"></ng-container>
</ng-template>

<ng-template #notExecutedDisplay>
  <ng-container
    *ngIf="notExecutedHistoryItemObject != null && !!!executionState.executed"
  >
    <hr />

    <div class="w-100 d-flex not-executed-container">
      <div class="completion-content-container upper-space">
        <textarea-input
          [initContent]="notExecutedHistoryItemObject.content"
          [subtitle]="
            'Reden: noteer waarom de opdracht niet uitgevoerd kon worden.'
          "
          [placeholder]="''"
          (answer)="contentChanged($event); saved = false"
        ></textarea-input>

        <div class="d-flex justify-content-between upper-space">
          <yes-no
            [subtitle]="'Bellen met Inpress. (03 825 40 16)'"
            [value]="notExecutedHistoryItemObject.callInpress"
            [neverShowExtraInstructions]="true"
            [nullIsFalse]="false"
            (answer)="callInpressChanged($event); saved = false"
          ></yes-no>
          <span
            class="mt-auto mb-auto font-italic"
            *ngIf="
              !!notExecutedHistoryItemObject.inpressCommunicationRegistration
                ?.by
            "
          >
            ({{
              notExecutedHistoryItemObject.inpressCommunicationRegistration.by
                ?.firstName
                | personName
                  : notExecutedHistoryItemObject
                      .inpressCommunicationRegistration.by?.lastName
            }},
            {{
              notExecutedHistoryItemObject.inpressCommunicationRegistration.date
                | date : 'dd/MM/yyyy HH:mm'
            }})
          </span>
        </div>
        <textarea-input
          *ngIf="notExecutedHistoryItemObject.callInpress"
          [initContent]="
            notExecutedHistoryItemObject.inpressCommunicationSummary
          "
          [subtitle]="'Met wie heb je gebeld:'"
          [placeholder]="'voornaam achternaam / telefoonnummer / gsm'"
          (answer)="inpressCommunicationSummaryChanged($event); saved = false"
        ></textarea-input>

        <div class="d-flex justify-content-between upper-space">
          <yes-no
            [subtitle]="'Bellen met makelaar.'"
            [value]="notExecutedHistoryItemObject.callClient"
            [neverShowExtraInstructions]="true"
            [nullIsFalse]="false"
            (answer)="callClientChanged($event); saved = false"
          ></yes-no>
          <span
            class="mt-auto mb-auto font-italic"
            *ngIf="
              !!notExecutedHistoryItemObject.clientCommunicationRegistration?.by
            "
          >
            ({{
              notExecutedHistoryItemObject.clientCommunicationRegistration.by
                ?.firstName
                | personName
                  : notExecutedHistoryItemObject.clientCommunicationRegistration
                      .by?.lastName
            }},
            {{
              notExecutedHistoryItemObject.clientCommunicationRegistration.date
                | date : 'dd/MM/yyyy HH:mm'
            }})
          </span>
        </div>
        <textarea-input
          *ngIf="notExecutedHistoryItemObject.callClient"
          [initContent]="
            notExecutedHistoryItemObject.clientCommunicationSummary
          "
          [subtitle]="'Met wie heb je gebeld:'"
          [placeholder]="'voornaam achternaam / telefoonnummer / gsm'"
          (answer)="clientCommunicationSummaryChanged($event); saved = false"
        ></textarea-input>

        <div class="upper-space">
          <textarea-input
            [initContent]="notExecutedHistoryItemObject.suggestedFollowUp"
            [subtitle]="
              'Wat moet er gebeuren of wat werd er verder afgesproken.'
            "
            [placeholder]="''"
            (answer)="suggestedFollowUpChanged($event); saved = false"
          ></textarea-input>
        </div>

        <div *ngIf="subProject.type !== 'Repo'" class="upper-space">
          <yes-no
            [subtitle]="stockedAtBranchSubtitle"
            [value]="stockedAtBranch"
            [neverShowExtraInstructions]="true"
            [nullIsFalse]="false"
            [disabled]="disabled"
            (answer)="stockedAtBranchChanged($event); saved = false"
          ></yes-no>

          <ng-container *ngIf="stockedAtBranch">
            <div class="d-flex less-top-space">
              <div [class.branch-choices-loaded]="branchChoices?.length > 0">
                <span style="display: block; margin-top: 14px"
                  >Waar: duid het filiaal aan:</span
                >
              </div>
              <div class="left-space">
                <ng-container
                  *ngIf="branchChoices?.length > 0; else showSpinner"
                >
                  <mat-form-field class="" appearance="outline">
                    <mat-select
                      matInput
                      placeholder="Filiaal"
                      [disabled]="disabled"
                      [(ngModel)]="notExecutedHistoryItemObject.stockAtBranchId"
                      (ngModelChange)="
                        stockedAtBranchIdChanged($event); saved = false
                      "
                    >
                      <mat-option
                        *ngFor="let option of branchChoices"
                        [value]="option.id"
                      >
                        {{ option.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
                <ng-template #showSpinner>
                  <mat-spinner color="primary" diameter="24"></mat-spinner>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="completion-images-container">
        <div class="d-flex">
          <div class="align-file-picker">
            <immo-ip-placer-tour-item-detail-not-executed-assets
              [notExecutedHistoryItemObject]="notExecutedHistoryItemObject"
              [subProject]="subProject"
              [immoIPPlacerTourItemDetailChangeStorageHandler]="
                immoIPPlacerTourItemDetailChangeStorageHandler
              "
              [shouldReloadNotExecutedHistoryItemAssets]="
                shouldReloadNotExecutedHistoryItemAssets
              "
              [flexImages]="false"
            ></immo-ip-placer-tour-item-detail-not-executed-assets>
          </div>
        </div>
      </div>
    </div>

    <div class="upper-space">
      <div class="reset-not-executed-link" (click)="resetNotExecuted()">
        <mat-icon class="reset-not-executed-icon">close</mat-icon>

        <span>Reset niet uitgevoerd</span>
      </div>
    </div>
  </ng-container>
</ng-template>
